module.exports = __webpack_public_path__ + "img/kreuzspitze.a771f27c.jpg";